import {
  ChevronDown,
  ChevronUp,
  Minus,
  Pause,
  Play,
  Plus,
  SkipBack,
} from "lucide-react";
import { formatTime } from "@scroll/shared-types/timeline-utils";

interface PlaybackControlsProps {
  isPlaying: boolean;
  currentTime: number;
  totalDuration: number;
  isCollapsed: boolean;
  zoomLabel: string;
  canZoomOut: boolean;
  canZoomIn: boolean;
  onTogglePlayback: () => void;
  onSeekTo: (time: number) => void;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onFitToWidth: () => void;
  onToggleCollapsed: () => void;
}

export default function PlaybackControls({
  isPlaying,
  currentTime,
  totalDuration,
  isCollapsed,
  zoomLabel,
  canZoomOut,
  canZoomIn,
  onTogglePlayback,
  onSeekTo,
  onZoomOut,
  onZoomIn,
  onFitToWidth,
  onToggleCollapsed,
}: PlaybackControlsProps) {
  return (
    <div className="timeline-playback-bar">
      <div className="timeline-playback-group">
        <button
          className="timeline-toolbar-btn"
          onClick={() => onSeekTo(0)}
          title="Go to start"
          aria-label="Go to start"
        >
          <SkipBack size={14} />
        </button>

        <button
          className="timeline-play-btn"
          onClick={onTogglePlayback}
          title={isPlaying ? "Pause (Space)" : "Play (Space)"}
          aria-label={isPlaying ? "Pause" : "Play"}
        >
          {isPlaying ? <Pause size={14} /> : <Play size={14} />}
        </button>

        <span className="timeline-time-display">
          {formatTime(currentTime)} / {formatTime(totalDuration)}
        </span>
      </div>

      <div className="timeline-playback-group timeline-zoom-controls" aria-label="Timeline zoom controls">
        <button
          className="timeline-toolbar-btn"
          onClick={onZoomOut}
          disabled={!canZoomOut}
          title="Zoom out"
          aria-label="Zoom out timeline"
        >
          <Minus size={14} />
        </button>
        <button
          className="timeline-toolbar-btn"
          onClick={onFitToWidth}
          title="Fit timeline to width"
          aria-label="Fit timeline to width"
        >
          <span className="timeline-fit-label">Fit</span>
        </button>
        <span className="timeline-zoom-label">{zoomLabel}</span>
        <button
          className="timeline-toolbar-btn"
          onClick={onZoomIn}
          disabled={!canZoomIn}
          title="Zoom in"
          aria-label="Zoom in timeline"
        >
          <Plus size={14} />
        </button>
      </div>

      <button
        className="timeline-toolbar-btn timeline-collapse-btn"
        onClick={onToggleCollapsed}
        title={isCollapsed ? "Expand timeline" : "Collapse timeline"}
        aria-label={isCollapsed ? "Expand timeline" : "Collapse timeline"}
        aria-expanded={!isCollapsed}
      >
        {isCollapsed ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
    </div>
  );
}
